import { connect } from 'react-redux'
import { flatten } from 'lodash'
import {
  updateOrderData,
  calculateOrderPricing,
  validateProductForm,
  submitProductForm,
  updateOrderedProductPricelistItem,
  updateOrderedProductOrderField
} from '../actions'
import orderSelector from '../selectors/orderSelector'
import ProductOrderFieldFormRow from '../components/ProductOrderFieldFormRow'
import OrderedProductPricelistItemFormRow from '../components/OrderedProductPricelistItemFormRow'
import ReactTooltipTrigger from '../../../components/ReactTooltipTrigger'

const mapStateToProps = (state) => {
  return {
    order: orderSelector(state),
    errors: state.errors,
    isSaveOrderLoading: state.isSaveOrderLoading,
    isCalculateOrderLoading: state.isCalculateOrderLoading,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateOrderData: data => dispatch(updateOrderData(data)),
    updateOrderedProductPricelistItem: (...args) => dispatch(updateOrderedProductPricelistItem(...args)),
    updateOrderedProductOrderField: (...args) => dispatch(updateOrderedProductOrderField(...args)),
    updateOrderCustomerParticipant: (...args) => dispatch(updateOrderCustomerParticipant(...args)),
    calculatePricing: _.throttle(() => dispatch(calculateOrderPricing()), 500),
    validateForm: () => dispatch(validateProductForm()),
    submitForm: () => dispatch(submitProductForm()),
  }
}

class NewOrderProductForm extends React.Component {
  handleFormSubmit(event) {
    event.preventDefault();
    this.props.submitForm().then(() => {
      this.props.onSave();
    });
  }

  handleChange(attribute, event) {
    let { value } = event.target;

    this.props.updateOrderData({
      [attribute]: value
    });

    this._triggerFormUpdate();
  }

  handleOrderedProductPricelistItemChange(nextOrderedItem) {
    this.props.updateOrderedProductPricelistItem(nextOrderedItem)
    this._triggerFormUpdate();
  }

  handleOrderedProductOrderFieldValueChange(parent, orderedField, value) {
    this.props.updateOrderedProductOrderField(parent, orderedField, value)
    this._triggerFormUpdate();
  }

  renderBaseErrors() {
    const errors = _(this.props.errors)
      .omit(["ordered_product_order_fields.value"])
      .values().flatten().value();

    return errors.length > 0 && (
      <div className="alert alert-danger">
        {errors.map((error, i) => <p key={i}>{error}</p>)}
      </div>
    )
  }

  renderCouponDiscountAttributesFormRows() {
    return (
      <div className="NewOrderProductForm-section">
        {this.props.order.data.coupon_offer_price_before_discount && (
          <div className="form-group NewOrderProductForm-coupon_offer_price_before_discount">
            <div className="form-label">
              {I18n.t("fe.order_details.coupon_offer_price_before_discount")}
            </div>
            <div className="form-wrapper">
              {st.formatMoney(this.props.order.data.coupon_offer_price_before_discount)}
            </div>
          </div>
        )}

        {(this.props.order.data.coupon_discount_amount || this.props.order.data.coupon_discount_percentage) && (
          <div className="form-group NewOrderProductForm-coupon_discount_amount">
            <div className="form-label">
              {I18n.t("fe.order_details.coupon_discount_amount")}
            </div>
            <div className="form-wrapper">
              {(() => {
                const formattedAmount = this.props.order.data.coupon_discount_amount && st.formatMoney(this.props.order.data.coupon_discount_amount)
                const formattedPercentage = this.props.order.data.coupon_discount_percentage && `${this.props.order.data.coupon_discount_percentage}%`
                if (formattedAmount && formattedPercentage) {
                  return `${formattedAmount} (${formattedPercentage})`
                } else {
                  return formattedAmount || formattedPercentage
                }
              })()}
            </div>
          </div>
        )}

        {this.props.order.data.coupon_offer_price && (
          <div className="form-group NewOrderProductForm-coupon_offer_price">
            <div className="form-label">
              {I18n.t("fe.order_details.coupon_offer_price")}
            </div>
            <div className="form-wrapper">
              {st.formatMoney(this.props.order.data.coupon_offer_price)}
            </div>
          </div>
        )}
      </div>
    )
  }

  renderProductPricelistItemsFormRows() {
    return (
      <div className="NewOrderProductForm-pricelist_items">
        {this.props.order.data.ordered_product_pricelist_items.map((orderedItem, i) => (
          <OrderedProductPricelistItemFormRow
            key={i}
            order={this.props.order}
            orderedItem={orderedItem}
            onChange={this.handleOrderedProductPricelistItemChange.bind(this)}
            />
        ))}
      </div>
    )
  }

  renderProductOrderFieldsFormRows() {
    const orderPricedOrderedFields = this.props.order.data.ordered_product_order_fields
      .filter(orderedField => orderedField.visible)
      .filter(orderedField => orderedField.product_order_field.has_pricing)

    const allPricedFields = orderPricedOrderedFields
      .concat(flatten(
        this.props.order.data.ordered_product_pricelist_items.map(oi => (
          oi.ordered_product_order_fields
            .filter(orderedField => orderedField.visible)
            .filter(orderedField => orderedField.product_order_field.has_pricing)
        ))
      ))
      .concat(flatten(
        this.props.order.data.order_customer_participants.map(oi => (
          oi.ordered_product_order_fields
            .filter(orderedField => orderedField.visible)
            .filter(orderedField => orderedField.product_order_field.has_pricing)
        ))
      ))

    return allPricedFields.length > 0 && (
      <div className="NewOrderProductForm-section">
        <h3 className="NewOrderProductForm-section-title">{I18n.t("attributes.product_options")}</h3>
        {orderPricedOrderedFields
          .map((orderedField, i) => (
            (
              <ProductOrderFieldFormRow
                key={i}
                order={this.props.order.data}
                orderedField={orderedField}
                onChange={this.handleOrderedProductOrderFieldValueChange.bind(this, this.props.order.data, orderedField)} />
            )
          ))}

        {this.props.order.data.ordered_product_pricelist_items.map(orderedItem => {
          const orderedFields = orderedItem.ordered_product_order_fields
            .filter(orderedField => orderedField.visible)
            .filter(orderedField => orderedField.product_order_field.has_pricing)

          return orderedFields.length > 0 && [
            <h4>{orderedItem.product_pricelist_item.name}</h4>,
            ...orderedFields
              .map((orderedField, i) => (
                (
                  <ProductOrderFieldFormRow
                    key={i}
                    order={this.props.order.data}
                    orderedField={orderedField}
                    onChange={this.handleOrderedProductOrderFieldValueChange.bind(this, orderedItem, orderedField)} />
                )
              ))
          ];
        })}

        {this.props.order.data.order_customer_participants.map(participant => {
          const orderedFields = participant.ordered_product_order_fields
            .filter(orderedField => orderedField.visible)
            .filter(orderedField => orderedField.product_order_field.has_pricing)

          return orderedFields.length > 0 && [
            <h4>{participant.display_name}</h4>,
            ...orderedFields
              .map((orderedField, i) => (
                (
                  <ProductOrderFieldFormRow
                    key={i}
                    order={this.props.order.data}
                    orderedField={orderedField}
                    onChange={this.handleOrderedProductOrderFieldValueChange.bind(this, participant, orderedField)} />
                )
              ))
          ];
        })}
      </div>
    )
  }

  renderPaymentProfileFormRow() {
    return this.props.order.data.possible_payment_profiles.length > 1 && (
      <div className="NewOrderProductForm-payment_profile">
        <div className="form-group">
          <label className="form-label" htmlFor="NewOrderProductForm-payment_profile_id">
            <div className="control-label">
              {I18n.t("fe.NewOrderProductForm.choose_payment_profile")}
            </div>
          </label>
          <div className="form-wrapper">
            <select
              className="form-control"
              id="NewOrderProductForm-payment_profile_id"
              value={this.props.order.data.payment_profile_id}
              onChange={this.handleChange.bind(this, "payment_profile_id")}>
              {this.props.order.data.possible_payment_profiles.map(pp =>
                <option key={pp.id} value={pp.id}>{pp.name}</option>
              )}
            </select>
          </div>
        </div>
      </div>
    );
  }

  renderServiceFeeFormRows() {
    return _.compact([
      ...(this.props.order.data.order_items || []).filter(oi => oi.item_type === "payment_profile_service_fee").map((orderItem, i) =>
        <div className="form-group NewOrderProductForm-service_fee" key={i}>
          <div className="form-label">
            {orderItem.name}
          </div>
          <div className="form-wrapper">
            {st.formatMoney( st.exchangeMoney(orderItem.total_price, this.props.order.data.customer_conversion_currency) )}
          </div>
        </div>
      ),

      (this.props.order.data.marketplace_service_fee_amount && this.props.order.data.marketplace_service_fee_amount.value > 0) && (
        <div className="form-group NewOrderProductForm-service_fee" key="marketplace_service_fee_amount">
          <div className="form-label">
            {I18n.t("fe.order_details.marketplace_service_fee")}
          </div>
          <div className="form-wrapper">
            <ReactTooltipTrigger tooltip={this.props.order.marketplace_service_fee_tooltip}>
              {st.formatMoney( st.exchangeMoney(this.props.order.data.marketplace_service_fee_amount, this.props.order.data.customer_conversion_currency) )}
              <i className="info-icon"></i>
            </ReactTooltipTrigger>
          </div>
        </div>
      ),

      (this.props.order.data.saas_service_fee_amount && this.props.order.data.saas_service_fee_amount.value > 0) && (
        <div className="form-group NewOrderProductForm-service_fee" key="saas_service_fee_amount">
          <div className="form-label">
            {I18n.t("fe.order_details.saas_service_fee")}
          </div>
          <div className="form-wrapper">
            <ReactTooltipTrigger tooltip={this.props.order.saas_service_fee_tooltip}>
              {st.formatMoney( st.exchangeMoney(this.props.order.data.saas_service_fee_amount, this.props.order.data.customer_conversion_currency) )}
              <i className="info-icon"></i>
            </ReactTooltipTrigger>
          </div>
        </div>
      ),
    ])
  }

  renderTotalAmountFormRow() {
    return (
      <div className="form-group NewOrderProductForm-total_amount">
        <div className="form-label">
          <h4>
            {I18n.t("fe.order_details.to_be_paid_total_amount")}
          </h4>
        </div>
        <div className="form-wrapper">
          <div className="price price--large">
            <div className="price-value">
              {st.formatMoney( st.exchangeMoney(this.props.order.data.total_amount_sum, this.props.order.data.customer_conversion_currency) )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderInstallmentsFormRows() {
    return this.props.order.data.installments.map((installment, i) => (
      <div className="NewOrderProductForm-installment" key={i}>
        <div className="form-group">
          <div className="form-label">
            {installment.name}
          </div>
          <div className="form-wrapper">
            {st.formatMoney( installment.frontend_amount )}
            {!!installment.frontend_sub_name && (
              <div className="help">
                ({installment.frontend_sub_name}: <strong>{st.formatMoney( installment.frontend_sub_amount )}</strong>)
              </div>
            )}
          </div>
        </div>

      </div>
    ));
  }

  renderPricesSummaryFormRows() {
    return (
      <div className="NewOrderProductForm-prices">
        {this.renderTotalAmountFormRow()}
        {this.renderInstallmentsFormRows()}
      </div>
    )
  }

  render() {
    return (
      <form onSubmit={this.handleFormSubmit.bind(this)} className="form form-horizontal NewOrderProductForm">
        {this.renderBaseErrors()}
        {this.props.order.data.product_type === "coupon" && this.renderCouponDiscountAttributesFormRows()}
        {["standard", "voucher", "ticket"].includes(this.props.order.data.product_type) && this.renderProductPricelistItemsFormRows()}
        {["standard", "voucher", "ticket"].includes(this.props.order.data.product_type) && this.renderProductOrderFieldsFormRows()}
        {["standard", "voucher", "ticket"].includes(this.props.order.data.product_type) && this.renderPaymentProfileFormRow()}
        {["standard", "voucher", "ticket"].includes(this.props.order.data.product_type) && this.renderServiceFeeFormRows()}
        {["standard", "voucher", "ticket"].includes(this.props.order.data.product_type) && this.renderPricesSummaryFormRows()}

        <div className="form-group">
          <div className="form-actions order-description-button-sticky">
            <button
              type="submit"
              className="btn btn-lg btn-primary"
              disabled={this.props.isSaveOrderLoading || this.props.isCalculateOrderLoading}
              onClick={this.handleFormSubmit.bind(this)}>
              {!this.props.isSaveOrderLoading && I18n.t("fe.NewOrderProductForm.submit")}
              {this.props.isSaveOrderLoading && <i className="fa fa-spin fa-circle-o-notch"></i>}
            </button>
          </div>
        </div>
      </form>
    );
  }

  _triggerFormUpdate() {
    this.props.calculatePricing();
    this.props.validateForm();
  }
}

const ConnectedNewOrderProductForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(NewOrderProductForm)

export default ConnectedNewOrderProductForm



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/NewOrderView/containers/NewOrderProductForm.jsx